<mat-card class="confirmation-card">
  <mat-card-header>
    <mat-card-title class="confirmation-title">
      We have received your request!
    </mat-card-title>
  </mat-card-header>

  <mat-card-content>
    <div class="confirmation-message">
      <p>
        Our booking team will check availability and email you the booking
        confirmation.
      </p>
      <p>
        If the selected property is no longer available, our booking team will
        phone you to offer a similar property.
      </p>
      <p>
        If you have any questions, please don't hesitate <br />
        to call us on <a href="tel:1800994412"><b>1800 994 412</b></a
        >.
      </p>
    </div>
  </mat-card-content>
</mat-card>
